import React, { Fragment } from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { func, string, arrayOf } from 'prop-types';

const StationNotFound = ({ hideModal, matchUrl, terms }) => (
  <Fragment>
    <Modal.Header>{terms[7]}</Modal.Header>
    <Modal.Content>{`${terms[11]} "${matchUrl}"`}</Modal.Content>
    <Modal.Actions>
      <Button primary onClick={() => hideModal()}>
        <Icon name="close" />
        {terms[12]}
      </Button>
    </Modal.Actions>
  </Fragment>
);

StationNotFound.propTypes = {
  hideModal: func.isRequired,
  matchUrl: string.isRequired,
  terms: arrayOf(string).isRequired
};

export default StationNotFound;
